module.exports = __webpack_public_path__ + "assets/AMinPerimeterDetailed.1cc30cb5b7a5044415bee196d5b3a154.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/AMinPerimeterDetailed.png
// module id = 453
// module chunks = 0